import { FC, ReactNode } from 'react'
import { useMobileDetector } from '../../hooks/use-mobile-detector'
import PdDisplaySwiperPanel from '../pd-display-swiper-panel/pd-display-swiper-panel'
import { SwiperSlide } from 'swiper/react'
import PdImage from '../pd-image/pd-image'
import TitleBar from './title-bar'
import { HeadingTag } from '../../common/pd-meta-components-types'
import SemanticText from '../standard/semantic-text'

type IOTSwiperProps = {
  data: { mediaUri: string; title: string }[]
  title: string[]
  desc?: string[]
  titleTag?: HeadingTag
  itemTitleTag?: HeadingTag
}
const DisplayCard: React.FC<{ title: string; mediaUri: string; titleTag?: HeadingTag }> = ({
  title,
  mediaUri,
  titleTag,
}) => (
  <div className={['flex flex-col items-center w-full laptop:w-384px'].join(' ')}>
    <div className={['w-full h-[105.3vw] laptop:h-452px bg-[#242424]'].join(' ')}>
      <PdImage src={mediaUri} enableMask={false} object="cover" width={'100%'} height={'100%'} />
    </div>
    <div
      className={[
        'w-full h-[25.3vw] px-3 laptop:h-112px laptop:px-6 flex items-center justify-center bg-[#1C1C1C]',
      ].join(' ')}
    >
      <SemanticText
        as={titleTag}
        defaultTag="span"
        className="text-center text-white/90 laptop:text-xl text-base font-semibold"
      >
        {title}
      </SemanticText>
    </div>
  </div>
)

const IOTSwiper: FC<IOTSwiperProps> = ({ data, title, desc, titleTag, itemTitleTag }) => {
  const isMobileDevice = useMobileDetector()

  return (
    <div className={['w-full bg-black py-15 px-6 laptop:px-0 laptop:py-30'].join(' ')}>
      <TitleBar title={title} desc={desc} titleTag={titleTag} />
      {data?.length > 3 || isMobileDevice ? (
        <PdDisplaySwiperPanel
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          slidesPerGroup={1}
          loop={!isMobileDevice || data?.length > 3}
          loopedSlides={data?.length}
          grabCursor
          slidesPerView={isMobileDevice ? 1 : 'auto'}
          spaceBetween={isMobileDevice ? 0 : 24}
          pagination={{
            el: '.pd-display-swiper-pagination',
            clickable: true,
            dynamicBullets: true,
          }}
          navigation={
            !isMobileDevice
              ? {
                  nextEl: '.pd-display-swiper-next',
                  prevEl: '.pd-display-swiper-prev',
                }
              : false
          }
          elClassName={{
            elClassName: [
              'absolute w-full h-2 -bottom-8 ',
              ' laptop:!w-300 laptop:h-25 laptop:mx-auto laptop:-bottom-25 laptop:left-[calc((100vw-1200px)/2)]',
            ].join(' '),
            paginationClassName: [
              'pd-display-swiper-pagination pd-pagination-container absolute flex items-center justify-center laptop:justify-start',
              'laptop:h-14 laptop:bottom-0',
            ].join(' '),
            nextElClassName: [
              'pd-display-swiper-next absolute cursor-pointer bg-center rotate-180',
              ' bottom-0 right-0 laptop:h-14 laptop:w-14 bg-white/20 bg-swiperBtn',
            ].join(' '),
            prevElClassName: [
              'pd-display-swiper-prev absolute cursor-pointer bg-center',
              ' bottom-0 right-20 laptop:h-14 laptop:w-14 bg-white/20 bg-swiperBtn',
            ].join(' '),
          }}
          slidesOffsetBefore={isMobileDevice ? 0 : (innerWidth - 1200) / 2}
        >
          {data?.map((item, index) => (
            <SwiperSlide key={index} className="w-full laptop:!w-fit">
              <DisplayCard {...item} titleTag={itemTitleTag} />
            </SwiperSlide>
          ))}
        </PdDisplaySwiperPanel>
      ) : (
        <div className={['laptop:w-300 laptop:mx-auto flex justify-between'].join(' ')}>
          {data?.map((item, index) => (
            <DisplayCard key={index} {...item} titleTag={itemTitleTag} />
          ))}
        </div>
      )}
    </div>
  )
}

export default IOTSwiper
